import { Link, useLocation } from 'react-router-dom';
import { Server, BarChart3, DollarSign, FileText } from 'lucide-react';

const SAP_NAV = [
  { href: '/sap-s4hana', label: 'Overview', icon: Server },
  { href: '/sap-s4hana/assessment', label: 'Readiness Assessment', icon: BarChart3 },
  { href: '/sap-s4hana/calculator', label: 'TCO Calculator', icon: DollarSign },
  { href: '/sap-s4hana/whitepaper', label: 'Whitepaper', icon: FileText },
];

const SapSubNav = () => {
  const { pathname } = useLocation();

  return (
    <div className="border-b border-slate-200 bg-white/80 backdrop-blur-md sticky top-[72px] z-30" data-testid="sap-subnav">
      <div className="max-w-7xl mx-auto px-6">
        <nav className="flex gap-1 overflow-x-auto py-2 -mb-px">
          {SAP_NAV.map(({ href, label, icon: Icon }) => {
            const active = pathname === href;
            return (
              <Link
                key={href}
                to={href}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all ${
                  active
                    ? 'bg-taxera-charcoal text-white'
                    : 'text-slate-500 hover:bg-slate-100 hover:text-slate-700'
                }`}
                data-testid={`sap-nav-${href.split('/').pop() || 'overview'}`}
              >
                <Icon className="w-3.5 h-3.5" strokeWidth={1.5} />
                {label}
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default SapSubNav;
